const checkIfAnchorIsInViewport = () =>{
    if(window.location.hash) {
        let theHash = window.location.hash;
        if (theHash.length > 1){
            let target = document.querySelector(theHash);
            if(target !== null){
                if(!isScrolledIntoView(target)){
                    target.scrollIntoView();
                }
            }
        }
    }
    function isScrolledIntoView(el) {
        let rect = el.getBoundingClientRect();
        let elemTop = rect.top;
        let elemBottom = rect.bottom;

        // Only completely visible elements return true:
        let isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
        // Partially visible elements return true:
        //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
        return isVisible;
    }
}
export default checkIfAnchorIsInViewport;